import React, {useEffect, useMemo, useState} from 'react';
import { connect } from 'react-redux';
import SaleFooter from '../Partials/SaleFooter/SaleFooter';
import { Addons } from '../Partials/Addons/Addons';
import { AddonsProduct } from '../Partials/Addons/AddonsProduct/AddonsProduct';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import { ServiceAddon } from '../Partials/Addons/ServiceAddon/ServiceAddon';
import { PopUpAddon } from '../Partials/PopUpAddon/PopUpAddon';
import { getEntryPopupAddons, mergeAddonEntryPopupCms } from '../Partials/Addons/addonEntryPopupHelpers';
import { updateAddons, reportDWH, goToPage, setIsLoadingShoppingCart} from '../saleJetBlockSlice';
import { getSalePricesAsync, getTechnicianTimesAsync, continueAfterInternetIdentityAsync } from '../saleBlockAsyncThunk';
import { gtag4 } from '../../../../utilities/analytics/tracking';
import { buildUrlAndOpenWindow } from '../../../../utilities/StringHelpers/StringHelpers';
import PackageDetails from '../Partials/PackageDetails/PackageDetails';

function AddonsPage(props) {
  const entryPopupAddons = useMemo(
    () => getEntryPopupAddons(props.addons, props.addonsEntryPopupConfig),
    [props.addons, props.addonsEntryPopupConfig],
  );
  const entryPopupSessionKey = props.entryPopupSessionKey;
  const [entryPopupIndex, setEntryPopupIndex] = useState(0);
  const [completedEntryPopups, setCompletedEntryPopups] = useState(false);
  const isShowingEntryPopup = !completedEntryPopups && entryPopupIndex < entryPopupAddons.length;
  const currentEntryPopupAddon = entryPopupAddons[entryPopupIndex];
  //page params
  let isDisplayFooter = props.addons?.length > 1;
  let currentPageView = props.addons?.length > 1  ? 'Addons' :  props.addons?.some((x)=> x.addonsList.some(item => item.isEquipment === true)) ? 'AddonsProduct' : 'ServiceAddon';
  let btnText = 'המשך';
  let currentPageFunction = handlePageContinue;
  let totalPrice = null;
  let priceText = '';
  let formid = 'saleJet';
  const funnel_name = (props.flowType === 'newCustomer') ? '_New' : '_Exists';


  const currentPageHeadline = (
    <div className='page-headline-wrapper width-440'>
      <p className='sale-title-big'>אתם כאן, לא תשדרגו?</p>
      <p className='sale-title-small'>תוספות ששווה להכיר</p>
    </div>
  );


  useEffect(() => {
    setEntryPopupIndex(0);
    setCompletedEntryPopups(false);
  }, [entryPopupSessionKey]);

  useEffect(() => {
    props.getSalePricesAsync();
  }, []);

  useEffect(() => {
    if (isShowingEntryPopup) {
      return;
    }

    props.reportDWH({ actionType: 'AddOns', status: 'Ongoing', messageText: 'AddOns Displayed' });
  }, [isShowingEntryPopup]);

  function getAddonsCount (addons){
    let count = addons.filter((x) => x.action == 'Add').length;
    return count;
  };

  function handleClickAddon(addons) {
    const count = getAddonsCount(addons);
    let data = {
      name: addons[0].name,
      count: count === 0 ? count + 1 : count,
    };
    props.updateAddons(data);
    newPageProcess(); //By moving to one page we are sent to the backend
    gtag4({
      event: `${props.saleType}_Step5_AddAddonButton`,
      step: '5',
      content: addons.id,
      action: 'AddAddonButton',
      button: 'תוסיפו לי',
      funnel_name: `${props.saleType}_Exists${funnel_name}_Customer`
     });
     props.reportDWH({ actionType: 'AddOns', status: 'Ongoing', messageText: 'Pick AddOns Clicked' });
  };

  function handleUpdateAddons(data) {
    props.updateAddons(data);
    props.getSalePricesAsync(data);
  };

  function advanceEntryPopup() {
    if (entryPopupIndex < entryPopupAddons.length - 1) {
      setEntryPopupIndex((index) => index + 1);
      return;
    }

    setCompletedEntryPopups(true);
  }

  function handleEntryPopupAdd(count) {
    handleUpdateAddons({
      name: currentEntryPopupAddon.name,
      count,
    });
    advanceEntryPopup();
  }

  function handleEntryPopupContinue() {
    advanceEntryPopup();
  }

  function handlePageContinue(addons) {
    let data = {
        name: addons[0].name,
        count: 0,
    };
    handleUpdateAddons(data);
    newPageProcess();
    gtag4({
      event: `${props.saleType}_Step5_AddonContinueWithoutButton`,
      step: '5',
      content: addons[0].name,
      action: 'AddonContinueWithoutButton',
      button: 'נמשיך בלי',
      funnel_name: `${props.saleType}_Exists${funnel_name}_Customer`
    });
  };

  function newPageProcess() {
    switch (props.saleType) {
      case 'tv':
          props.goToPage('addressPage');
        break;
      case 'app':
        if (props.flowType == 'existsCustomer') {
          props.getCustomerAddresses();
        }else {
          props.goToPage('personalInfoPage');
        }
        break;
      case 'triple':
        props.getTechnicianTimesAsync();
        break;
      case 'internet':
        if (props.isFullAuthenticated) {
          props.continueAfterInternetIdentityAsync();
        } else {
          props.goToPage('internetCustomerInfoPage');
        }
        break;
    };
  };

  function submitFooter(){
    newPageProcess();
    gtag4({
     event: `${props.saleType}_Step5_AddonsContinueButton`,
     step: '5',
     button: btnText,
     action: 'AddonsContinueButton',
     funnel_name: `${props.saleType}_Exists${funnel_name}_Customer`
    });
    props.reportDWH({ actionType: 'AddOns', status: 'Ongoing', messageText: 'Pick AddOns Clicked' });
  };

  switch (currentPageView) {
    case 'Addons':
      currentPageView =
      <Addons
        addons={props.addons}
        handleUpdateAddons={handleUpdateAddons}
        updateStore={props.updateAddons}
        reportDWH={props.reportDWH}
        flowType={props.flowType}
        saleType={props.saleType}
        isLoadingShoppingCart={props.isLoadingShoppingCart}
      >
      </Addons>
      break;
    case 'AddonsProduct':
      currentPageView =
      <AddonsProduct
        addons={props.addons}
        handleUpdateAddons={handleUpdateAddons}
        gtag4={gtag4}
        saleType={props.saleType}
        flowType={funnel_name}
        isLoadingShoppingCart={props.isLoadingShoppingCart}
        buildUrlAndOpenWindow={buildUrlAndOpenWindow}
        getAddonsCount={getAddonsCount}
      >
      </AddonsProduct>
      break;
    case 'ServiceAddon':
      currentPageView =
      <ServiceAddon
        serviceAddons={props.addons}
        gtag4={gtag4}
        saleType={props.saleType}
        flowType={funnel_name}
        buildUrlAndOpenWindow={buildUrlAndOpenWindow}
      >
      </ServiceAddon>
      break;
    default:
  };

  return (
    <div className='slideAnimation'>
      <div className='package-details-wrapper package-details-wrapper--step-bar'>
        <PackageDetails />
      </div>
      {props.addons?.length > 1 && currentPageHeadline}
      <div className='sale-page-content width-480'>
        {currentPageView}
        {props.addons?.length > 1 &&
          <SaleFooter
            isDisplayFooter={isDisplayFooter}
            btnText={btnText}
            onclick={submitFooter}
            price={totalPrice}
            priceText={priceText}
            formid={formid}
            className={'cancelFixed'}
          />
        }
      </div>
      {props.addons?.length === 1 && !isShowingEntryPopup &&
        <div className={`btn-wrapper-single-addons`}>
          <BtnSubmit formid='catalog-card' onclick={()=> handleClickAddon(props.addons[0].addonsList)} text='הוסיפו לי'></BtnSubmit>
          <BtnSubmit className='btn-submit-outline' formid='catalog-card' onclick={()=> currentPageFunction(props.addons[0].addonsList)} text='נמשיך בלי'></BtnSubmit>
        </div>
      }
      {isShowingEntryPopup && (
        <PopUpAddon
          addon={currentEntryPopupAddon}
          showPopUp={isShowingEntryPopup}
          onClose={handleEntryPopupContinue}
          onAdd={handleEntryPopupAdd}
          onContinue={handleEntryPopupContinue}
          handleUpdateAddons={handleUpdateAddons}
          saleType={props.saleType}
          flowType={props.flowType}
          reportDWH={props.reportDWH}
          isLoadingShoppingCart={props.isLoadingShoppingCart}
          buildUrlAndOpenWindow={buildUrlAndOpenWindow}
        />
      )}
    </div>
  )
};

  function groupArrayOfObjects(listAddons){
    const groups = listAddons.reduce((groups, item) => {
      if (!groups[item.name]) {
        groups[item.name] = [];
      }
      groups[item.name].push(item);
      return groups;
    }, {});

    const groupArrays = Object.keys(groups).map((name) => {
      const group = groups[name];
      return {
        name,
        isEquipment:group[0].isEquipment,
        cmsData: group[0]?.cmsData,
        addonsList: group,

      };
    });
    return groupArrays;
  };

  const mapStateToProps = (state) => {
    const entryPopupConfig = state.saleJetBlock.selectedPackage?.addonsEntryPopupConfig || {};
    const groupedAddons = groupArrayOfObjects(state.saleJetBlock.saleCatalog?.addons).map((addon) =>
      mergeAddonEntryPopupCms(addon, entryPopupConfig),
    );

    return {
      addons: groupedAddons,
      addonsEntryPopupConfig: entryPopupConfig,
      entryPopupSessionKey: `${state.saleJetBlock.selectedPackage?.offerId}|${(state.saleJetBlock.selectedPackage?.addons || []).join('|')}`,
      saleType: state.saleJetBlock.saleType,
      flowType: state.saleJetBlock.flowType, // for APP
      isLoadingShoppingCart: state.saleJetBlock.isLoadingShoppingCart,
      isFullAuthenticated: state.authentication?.loginData?.isFullAuthenticated,
    };
  };

  const mapDispatchToProps = {
    getTechnicianTimesAsync,
    getSalePricesAsync,
    continueAfterInternetIdentityAsync,
    updateAddons,
    goToPage,
    reportDWH,
    setIsLoadingShoppingCart
  };

export default connect(mapStateToProps, mapDispatchToProps)(AddonsPage);
